import { bffURL, environment, sourceTrackingAppId } from '../config'
import { newId, track } from './sourceTracking'

const APP_TITLE = 'applicant-ui'
const APP_PACKAGE_NAME = 'AmplifyService'
const CLIENT_ID = 'applicant-ui'

let producer = null

/**
 * Browser producer for the applicant-bff Source Tracking collector. The service name and the
 * `appId`/`packageName` identity are kept from the retired Pinpoint SDK so `raw_events/` history
 * stays queryable by the same keys.
 */
export default class AmplifyService {
  static initialize () {
    // One collector session per page load: re-initializing (e.g. route remounts) keeps the same id.
    const session = producer
      ? { sessionId: producer.sessionId, sessionStartTimestamp: producer.sessionStartTimestamp }
      : { sessionId: newId(), sessionStartTimestamp: Date.now() }
    producer = {
      environment,
      appId: sourceTrackingAppId,
      title: APP_TITLE,
      packageName: APP_PACKAGE_NAME,
      clientId: CLIENT_ID,
      ...session
    }
  }

  /** `event` may carry `migrationEventId`, `sessionId` and `sessionStartTimestamp` to keep stable ids across remounts. */
  static sendEvent (event) {
    if (!producer) {
      return
    }
    try {
      track(producer, bffURL, event)
    } catch (e) {
      console.error('Error sending source tracking event', e)
    }
  }
}
